<!--
  A tiny line for a row: the shape of a number over time, with its last point marked.
  Purely visual (the row already says the number), so it's hidden from screen readers.
-->
<script lang="ts">
  let {
    values,
    color = "var(--series-1)",
    width = 140,
    height = 32,
  }: { values: number[]; color?: string; width?: number; height?: number } = $props();

  const min = $derived(Math.min(0, ...values));
  const max = $derived(Math.max(1, ...values));
  const x = (i: number) => 2 + (values.length <= 1 ? 0 : (i / (values.length - 1)) * (width - 6));
  const y = (v: number) => 2 + (height - 4) - ((v - min) / (max - min || 1)) * (height - 4);
  const d = $derived(values.map((v, i) => `${i ? "L" : "M"}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(""));
</script>

{#if values.length > 1}
  <svg class="spark" {width} {height} aria-hidden="true">
    {#if min < 0}<line x1="0" x2={width} y1={y(0)} y2={y(0)} stroke="var(--rule)" />{/if}
    <path d="{d}L{x(values.length - 1)},{y(min)}L{x(0)},{y(min)}Z" fill={color} opacity="0.12" />
    <path {d} fill="none" stroke={color} stroke-width="2" stroke-linejoin="round" stroke-linecap="round" />
    <circle cx={x(values.length - 1)} cy={y(values.at(-1)!)} r="3" fill={color} />
  </svg>
{/if}

<style>
  .spark {
    display: block;
    overflow: visible;
  }
</style>
